var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscHorizontal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 146,
    viewBox: "0 0 461 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5903 10.0002C37.7964 10.0002 9.59033 38.2041 9.59033 72.9952C9.59033 107.786 37.7964 135.99 72.5903 135.99L387.88 135.99C422.674 135.99 450.88 107.786 450.88 72.9952C450.88 38.2041 422.674 10.0002 387.88 10.0002L72.5903 10.0002Z",
    stroke: "url(#paint0_linear_55_2007)",
    strokeWidth: 18.61,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_2007",
    x1: 460.18,
    y1: 72.9902,
    x2: 0.280335,
    y2: 72.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AD7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#28AD7E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscHorizontal1);
export default __webpack_public_path__ + "static/media/miscHorizontal1.c9a144af9541ac755c782f31593d1691.svg";
export { ForwardRef as ReactComponent };